exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{\r\n    background-color: #242f42;\n}\n.login-wrap{\r\n    background: #324157;\n}\n.plugins-tips{\r\n    background: #eef1f6;\n}\n.plugins-tips a{\r\n    color: #20a0ff;\n}\n.el-upload--text em {\r\n    color: #20a0ff;\n}\n.pure-button{\r\n    background: #20a0ff;\n}\n.tags-li.active {\r\n    border: 1px solid #409EFF;\r\n    background-color: #409EFF;\n}\n.message-title{\r\n    color: #20a0ff;\n}\n.collapse-btn:hover{\r\n    background: rgb(40,52,70);\n}", ""]);

// exports
